// extracted by mini-css-extract-plugin
module.exports = {"para":"departments_para__TbF3j","paracs":"departments_paracs__3TlCL","icn":"departments_icn__37gI8","but_read":"departments_but_read__2Lz40","card":"departments_card__Z_g7h"};